export default {
  required: (fieldName, lineNumber) => `${fieldName} is required on line ${lineNumber}`,
  mismatch: (fieldName, lineNumber) => `${fieldName} should be valid on line ${lineNumber}`,
  oneOf: (fieldName, statesList, lineNumber) =>
    `${fieldName} should be one of ${statesList} on line ${lineNumber}`,
  default: (fieldName, lineNumber) => `${fieldName} on line ${lineNumber} has some errors`
};
